export default __webpack_public_path__ + "static/media/blue-cross-glyph.d2bba75c.png";